<template>
    <div id="main-content" class="add-cancel">
        <el-col :offset="1" :span="22">
            <PageTitle :title="title" :backLink="backLink"></PageTitle>
            <form>
                <el-row>
                    <el-col :span="4">
                        <span class="required-star">* </span><span class="form-lable">{{ $t('common.student') }}</span>
                    </el-col>

                    <el-col :span="10">
                        <el-select v-model="studentId" filterable :placeholder="$t('common.please_select')">
                            <el-option
                                v-for="student in sortedStudentList"
                                :key="student.id"
                                :label="getStudentLabel(student)"
                                :value="student.id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="4">
                        <span class="required-star">* </span><span class="form-lable">{{ $t('common.type') }}</span>
                    </el-col>

                    <el-col :span="10">
                        <el-select v-model="type" :placeholder="$t('common.please_select')">
                            <el-option :label="$t('schedule.cancel_by_date')"
                                    :value="SCHEDULE_CANCEL_DATE"></el-option>
                            <el-option :label="$t('schedule.cancel_by_day')"
                                       :value="SCHEDULE_CANCEL_DAY"></el-option>
                            <el-option :label="$t('schedule.cancel_by_period')"
                                       :value="SCHEDULE_CANCEL_PERIOD"></el-option>
                            <el-option :label="$t('schedule.booking')"
                                       :value="SCHEDULE_BOOKING"></el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <template v-if="type === SCHEDULE_CANCEL_DATE">
                    <el-row>
                        <el-col :span="4">
                            <span class="required-star">* </span><span class="form-lable">{{ $t('common.date') }}</span>
                        </el-col>

                        <el-col :span="10">
                            <el-date-picker
                                v-model="data.date.date"
                                type="date"
                                :placeholder="$t('common.pick_a_date')"
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="4">
                            <span class="required-star">* </span><span class="form-lable">{{ $t('common.route') }}</span>
                        </el-col>

                        <el-col :span="10">
                            <el-select v-model="data.date.route_type" :placeholder="$t('common.please_select')">
                                <el-option
                                        v-for="route in routeTypeList"
                                        :key="route.id"
                                        :label="$t(route.label)"
                                        :value="route.id">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </template>

                <template v-else-if="type === SCHEDULE_CANCEL_DAY">
                    <el-row>
                        <el-col :span="4">
                            <span class="required-star">* </span><span class="form-lable">{{ $t('common.day') }}</span>
                        </el-col>

                        <el-col :span="10">
                            <el-select v-model="data.day.day" :placeholder="$t('common.please_select')">
                                <el-option
                                    v-for="(day, key) in DAY_LIST_FULL"
                                    :key="key"
                                    :label="$t(`calendar.full_day.${day}`)"
                                    :value="key">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="4">
                            <span class="required-star">* </span><span class="form-lable">{{ $t('common.month') }}</span>
                        </el-col>

                        <el-col :span="10">
                            <el-select v-model="data.day.month" :placeholder="$t('common.please_select')">
                                <el-option
                                    v-for="(month, key) in MONTH_LIST"
                                    :key="key"
                                    :label="$t(`calendar.month.${month}`)"
                                    :value="key">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="4">
                            <span class="required-star">* </span><span class="form-lable">{{ $t('common.year') }}</span>
                        </el-col>

                        <el-col :span="10">
                            <el-select v-model="data.day.year" :placeholder="$t('common.please_select')">
                                <el-option
                                    v-for="year in yearList"
                                    :key="year"
                                    :label="year"
                                    :value="year">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="4">
                            <span class="required-star">* </span><span class="form-lable">{{ $t('common.route') }}</span>
                        </el-col>

                        <el-col :span="10">
                            <el-select v-model="data.day.route_type" :placeholder="$t('common.please_select')">
                                <el-option
                                        v-for="route in routeTypeList"
                                        :key="route.id"
                                        :label="$t(route.label)"
                                        :value="route.id">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </template>

                <template v-else-if="type === SCHEDULE_CANCEL_PERIOD">
                    <el-row>
                        <el-col :span="4">
                            <span class="required-star">* </span><span class="form-lable">{{ $t('common.start_date') }}</span>
                        </el-col>

                        <el-col :span="10">
                            <el-date-picker
                                v-model="data.period.start.date"
                                type="date"
                                :placeholder="$t('common.pick_a_date')"
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="4">
                            <span class="required-star">* </span><span class="form-lable">{{ $t('common.route') }} ({{ $t('common.start_date') }})</span>
                        </el-col>

                        <el-col :span="10">
                            <el-select v-model="data.period.start.route_type" :placeholder="$t('common.please_select')">
                                <el-option
                                        v-for="route in routeTypeList"
                                        :key="route.id"
                                        :label="$t(route.label)"
                                        :value="route.id">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="4">
                            <span class="required-star">* </span><span class="form-lable">{{ $t('common.end_date') }}</span>
                        </el-col>

                        <el-col :span="10">
                            <el-date-picker
                                v-model="data.period.end.date"
                                type="date"
                                :placeholder="$t('common.pick_a_date')"
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="4">
                            <span class="required-star">* </span><span class="form-lable">{{ $t('common.route') }} ({{ $t('common.end_date') }})</span>
                        </el-col>

                        <el-col :span="10">
                            <el-select v-model="data.period.end.route_type" :placeholder="$t('common.please_select')">
                                <el-option
                                    v-for="route in routeTypeList"
                                    :key="route.id"
                                    :label="$t(route.label)"
                                    :value="route.id">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </template>

                <template v-else-if="type === SCHEDULE_BOOKING">
                    <el-row>
                        <el-col :span="4">
                            <span class="required-star">* </span><span class="form-lable">{{ $t('common.date') }}</span>
                        </el-col>

                        <el-col :span="10">
                            <el-date-picker
                                v-model="data.booking.date"
                                type="date"
                                :placeholder="$t('common.pick_a_date')"
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="4">
                            <span class="required-star">* </span><span class="form-lable">{{ $t('common.route') }}</span>
                        </el-col>

                        <el-col :span="10">
                            <el-select v-model="data.booking.route_type" :placeholder="$t('common.please_select')">
                                <el-option
                                    v-for="route in routeTypeList"
                                    :key="route.id"
                                    :label="$t(route.label)"
                                    :value="route.id">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </template>

                <el-row>
                    <el-col :span="4">
                        <span class="required-star">* </span><span class="form-lable">{{ $t('schedule.reason') }}</span>
                    </el-col>

                    <el-col :span="10">
                        <el-input type="textarea" :placeholder="$t('schedule.reason')" v-model="reason"></el-input>
                    </el-col>
                </el-row>

                <el-row style="padding: 50px 0">
                    <el-button style="font-size: 20px; width: 30%" type="success" @click="submitAction" :disabled="!canSave">{{ $t('common.submit') }}
                    </el-button>
                </el-row>
            </form>
        </el-col>
    </div>
</template>

<script>
  // import
  import PageTitle from '@/components/PageTitle'
  import {
    SCHEDULE_CANCEL_DATE,
    SCHEDULE_CANCEL_DAY,
    SCHEDULE_CANCEL_PERIOD,
    SCHEDULE_BOOKING,
    ROUTE_PICKUP,
    ROUTE_DROP,
    ROUTE_BOTH,
    DAY_LIST_FULL,
    MONTH_LIST
  } from '@/config'
  import { basicSort } from '@/utils'

  export default {
    name: "AddCancel",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: '/schedule/cancel',
        title: 'schedule.add_cancel',
        type: '',
        studentId: null,
        reason: null,
        data: {
          date: {
            date: null,
            route_type: null
          },
          day: {
            day: null,
            month: null,
            year: null,
            route_type: null
          },
          period: {
            start: {
              date: null,
              route_type: null
            },
            end: {
              date: null,
              route_type: null
            }
          },
          booking: {
            date: null,
            route_type: null
          },
        },
        studentList: [],
        SCHEDULE_CANCEL_DATE,
        SCHEDULE_CANCEL_DAY,
        SCHEDULE_CANCEL_PERIOD,
        SCHEDULE_BOOKING,
        DAY_LIST_FULL,
        MONTH_LIST,
        pickerOptions: {
          disabledDate: (date) => {
            let currentDate = this.$moment().format('YYYY-MM-DD')
            let currentTime = this.$moment(currentDate).valueOf()
            let time = this.$moment(date).valueOf()

            return time < currentTime
          }
        },
        routeTypeList: [
          {
            id: ROUTE_PICKUP,
            label: 'common.pickup_route'
          },
          {
            id: ROUTE_DROP,
            label: 'common.drop_route'
          },
          {
            id: ROUTE_BOTH,
            label: 'common.both'
          }
        ],
        yearList: []
      }
    },
    created () {
      let currentYear = parseInt(this.$moment().format('YYYY'))
      this.yearList = [currentYear, currentYear + 1]
    },
    methods: {
      submitAction: function () {
        this.$store.commit('openConfirm', {
          title: this.$t('schedule.add_cancel'),
          message: this.getConfirm(),
          width: '40%',
          callback: () => {
            let successCallback = (response) => {
              if (response.data.data && response.data.data.cancel_success) {
                let message = this.getCancelMessage(
                  response.data.data.cancel_success,
                  response.data.data.cancel_fail
                )

                this.$store.commit('openNotification', {
                  type: 'success',
                  message
                })
              }

              this.$router.push({path: '/schedule/cancel'})
            }

            let data

            switch (this.type) {
              case SCHEDULE_CANCEL_DATE:
                data = this.data.date
                break;
              case SCHEDULE_CANCEL_DAY:
                data = this.data.day
                break;
              case SCHEDULE_CANCEL_PERIOD:
                data = this.data.period
                break;
              default:
                data = this.data.booking
            }

            data.reason = this.reason

            this.$store.dispatch('schedule/createCancel', {
              data: {
                student_id: this.studentId,
                type: this.type,
                data
              },
              successCallback
            })
          }
        })
      },
      getStudentLabel (student) {
        let label = []

        if (student.name) {
          label.push(student.name)
        }

        if (student.furigana) {
          label.push(student.furigana)
        }

        if (student.romaji) {
          label.push(student.romaji)
        }

        if (student.class_info && student.class_info.name) {
          label.push(student.class_info.name)
        }

        if (student.place_info && student.place_info.name) {
          label.push(student.place_info.name)
        }

        return label.join(' - ')
      },
      getRouteTypeLabel (id) {
        let routeType = this.routeTypeList.find((item) => {
          return item.id === id
        })

        return routeType ? this.$t(routeType.label) : ''
      },
      getDayLabel (id) {
        let day = ''

        for (let key in DAY_LIST_FULL) {
          if (key === id) {
            day = this.$t(`calendar.full_day.${DAY_LIST_FULL[key]}`)
            break
          }
        }

        return day
      },
      getMonthLabel (id) {
        let month = ''

        for (let key in MONTH_LIST) {
          if (key === id) {
            month = this.$t(`calendar.month.${MONTH_LIST[key]}`)
            break
          }
        }

        return month
      },
      getTypeLabel (id) {
        switch (id) {
          case SCHEDULE_CANCEL_DATE:
            return this.$t('schedule.cancel_by_date')
          case SCHEDULE_CANCEL_DAY:
            return this.$t('schedule.cancel_by_day')
          case SCHEDULE_CANCEL_PERIOD:
            return this.$t('schedule.cancel_by_period')
          default:
            return this.$t('schedule.booking')
        }
      },
      getConfirm () {
        let student = this.studentList.find((item) => {
          return item.id === this.studentId
        })

        let message = `
            <div>${this.$t('common.student')}: <strong>${this.getStudentLabel(student)}</strong></div>
            <div>${this.$t('common.type')}: <strong>${this.getTypeLabel(this.type)}</strong></div>
        `

        switch (this.type) {
          case SCHEDULE_CANCEL_DATE:
            message += this.getDateConfirm()
            break
          case SCHEDULE_CANCEL_DAY:
            message += this.getDayConfirm()
            break
          case SCHEDULE_CANCEL_PERIOD:
            message += this.getPeriodConfirm()
            break
          default:
            message += this.getBookingConfirm()
        }

        message += `<div>${this.$t('schedule.reason')}: <strong>${this.reason}</strong></div>`

        return `<div style="text-align: left;">${message}</div>`
      },
      getDateConfirm () {
        return `
            <div>${this.$t('common.date')}: <strong>${this.data.date.date}</strong></div>
            <div>${this.$t('common.route')}: <strong>${this.getRouteTypeLabel(this.data.date.route_type)}</strong></div>
        `
      },
      getDayConfirm () {
        return `
            <div>${this.$t('common.day')}: <strong>${this.getDayLabel(this.data.day.day)}</strong></div>
            <div>${this.$t('common.month')}: <strong>${this.getMonthLabel(this.data.day.month)}</strong></div>
            <div>${this.$t('common.year')}: <strong>${this.data.day.year}</strong></div>
            <div>${this.$t('common.route')}: <strong>${this.getRouteTypeLabel(this.data.day.route_type)}</strong></div>
        `
      },
      getPeriodConfirm () {
        return `
            <div>${this.$t('common.start_date')}: <strong>${this.data.period.start.date}</strong></div>
            <div>${this.$t('common.route')} (${this.$t('common.start_date')}): <strong>${this.getRouteTypeLabel(this.data.period.start.route_type)}</strong></div>
            <div>${this.$t('common.end_date')}: <strong>${this.data.period.end.date}</strong></div>
            <div>${this.$t('common.route')} (${this.$t('common.end_date')}): <strong>${this.getRouteTypeLabel(this.data.period.end.route_type)}</strong></div>
        `
      },
      getBookingConfirm () {
        return `
            <div>${this.$t('common.date')}: <strong>${this.data.booking.date}</strong></div>
            <div>${this.$t('common.route')}: <strong>${this.getRouteTypeLabel(this.data.booking.route_type)}</strong></div>
        `
      },
      getCancelMessage (cancelSuccessList, cancelFailList) {
        let message

        if (!cancelFailList.length) {
          message = this.$t('schedule.cancel_success')
        } else {
          message = '<div class="error">' + this.getCancelSuccessPartMessage(cancelSuccessList) + '</div>'
        }

        return message
      },
      getCancelSuccessPartMessage (cancelSuccessList) {
        let message = []

        message.push(this.$t('schedule.cancel_message_start'))

        cancelSuccessList.forEach((cancelSuccess) => {
          let date = cancelSuccess.date.split('-')
          let day = this.$moment(cancelSuccess.date).format('E')
          let route

          if (cancelSuccess.route_type === ROUTE_PICKUP) {
            route = this.$t('schedule.cancel_pickup')
          } else if (cancelSuccess.route_type === ROUTE_DROP) {
            route = this.$t('schedule.cancel_drop')
          } else {
            route = this.$t('schedule.cancel_both')
          }

          message.push(this.$t('schedule.cancel_day_message', {
            year: date[0],
            month: date[1],
            date: date[2],
            day: this.$t(`calendar.full_day.${DAY_LIST_FULL[day]}`),
            route: route
          }))
        })

        message.push(this.$t('schedule.cancel_message_end'))

        return message.join('<br />')
      }
    },
    mounted: function () {
      this.$store.dispatch('schedule/retrieveStudentMasterListNoFilter', {
        successCallback: (response) => {
          this.studentList = [].concat(response.data.student_list)
        }
      })
    },
    computed: {
      sortedStudentList: function () {
        let sortedStudentList = [].concat(this.studentList)

        return sortedStudentList.sort((before, after) => basicSort(before, after, 'romaji'))
      },
      canSave: function () {
        if (!this.studentId) {
          return false
        }

        if (!this.type) {
          return false
        }

        if (!this.reason) {
          return false
        }

        switch (this.type) {
          case SCHEDULE_CANCEL_DATE:
            return this.data.date.date && this.data.date.route_type
          case SCHEDULE_CANCEL_DAY:
            return this.data.day.day && this.data.day.month && this.data.day.year && this.data.day.route_type
          case SCHEDULE_CANCEL_PERIOD:
            return this.data.period.start.date && this.data.period.start.route_type
              && this.data.period.end.date && this.data.period.end.route_type
          default:
            return this.data.booking.date && this.data.booking.route_type
        }
      }
    }
  }
</script>

<style lang="scss">
    .add-cancel {
        form {
            .el-row {
                margin-top: 20px;
            }

            .input, .el-input, .el-select {
                width: 100%;
            }
        }
    }
</style>
